import BlazinAttachment from './BlazinAttachment';
export default BlazinAttachment;